import { render, staticRenderFns } from "./TaskInformation.vue?vue&type=template&id=d538397e"
import script from "./TaskInformation.vue?vue&type=script&lang=js"
export * from "./TaskInformation.vue?vue&type=script&lang=js"
import style0 from "./TaskInformation.vue?vue&type=style&index=0&id=d538397e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports